/**
 * 折叠展开 + ID.me 验证弹窗（Product Overview / Verification）。
 * 采用 document 级事件委托，不依赖任何 section id 或包裹元素，
 * 因此变体切换、快速加购弹窗（choose options）等动态插入的内容无需重新绑定即可生效。
 * 注意：此文件必须在 theme.liquid 全站加载——快速加购弹窗只注入 <product-info> 内部的 HTML，
 * section 内联脚本不会随之执行，集合页等非详情页上只有全局脚本可用。
 */
(function () {
  if (window.__productInfoDisclosureBound) return;
  window.__productInfoDisclosureBound = true;

  var TITLE_SELECTOR = '.product_info_description_box_title[id^="Description-"], .product_info_verification_box_title[id^="Verification-"]';
  var VERIFICATION_LINK_SELECTOR = '.product_info_verification_box [data-verification-url]';

  function toggle(title) {
    var expanded = title.classList.toggle('active');
    title.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function openVerificationPopup(url) {
    var left = (screen.width - 600) / 2;
    var top = (screen.height - 800) / 2;
    window.open(
      url,
      'verification',
      'width=600,height=800,scrollbars=yes,toolbar=no,location=no,directories=no,status=no,menubar=no,resizable=yes,left=' +
        left +
        ',top=' +
        top
    );
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest(VERIFICATION_LINK_SELECTOR);
    if (link) {
      var url = link.getAttribute('data-verification-url');
      if (!url) return;
      event.preventDefault();
      openVerificationPopup(url);
      return;
    }

    var title = event.target.closest(TITLE_SELECTOR);
    if (title) toggle(title);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
    var title = event.target.closest(TITLE_SELECTOR);
    if (!title) return;
    event.preventDefault();
    toggle(title);
  });
})();
